module.exports = __webpack_public_path__ + "img/BE0205764318.048a5126.png";